export default "__VITE_ASSET__B39KLd_R__"